import {
  VIEW_VEHICLE_PLATE,
  CREATE_VEHICLE_PLATE,
} from 'utils/roles/permissions';
import Plate from './Plate';
import { withConnectedAdditional } from '../AdditionalCollapse';
import { EDIT_VEHICLE_PLATE } from '../../../../../utils/roles/permissions';

export default withConnectedAdditional({
  identifierForView: EDIT_VEHICLE_PLATE,
  identifierForAdd: EDIT_VEHICLE_PLATE,
})(Plate);
